package com.nonopn.skydome.common.app.utils

import kotlinx.browser.document
import kotlinx.browser.window

private const val AppLanguageStorageKey = "strike-radar.app-language"

actual fun setSystemLocale(languageCode: String) {
    val language = normalizeLanguage(languageCode)
    updateBrowserLanguage(language)
    document.documentElement?.setAttribute("lang", language)
}

actual fun getSystemLanguage(): String {
    val language = normalizeLanguage(
        (readSavedLanguage() ?: window.navigator.language).replace('_', '-').substringBefore('-').lowercase()
    )
    // Initialize the resource locale before the first composition, including after a reload.
    setSystemLocale(language)
    return language
}

private fun readSavedLanguage(): String? {
    val storageKey = AppLanguageStorageKey
    return js("""
        (function () {
            if (window.__strikeRadarLocale) { return window.__strikeRadarLocale; }
            try { return window.localStorage.getItem(storageKey); }
            catch (error) { return null; }
        })()
    """) as? String
}

private fun updateBrowserLanguage(language: String) {
    val storageKey = AppLanguageStorageKey
    // Compose resources read navigator.languages, not the document's lang attribute.
    // This follows JetBrains' web locale workaround and notifies its resource environment.
    js("""
        if (window.__strikeRadarLocale !== language) {
            Object.defineProperty(window.navigator, 'languages', {
                configurable: true,
                get: function () { return [window.__strikeRadarLocale]; }
            });
            window.__strikeRadarLocale = language;
            window.dispatchEvent(new Event('languagechange'));
        }
        try { window.localStorage.setItem(storageKey, language); }
        catch (error) { /* Storage may be disabled; switching still works for this session. */ }
    """)
}
